export const MOBILE_LEAD_FORM_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    status: true,
  },

  MOBILE_LEAD_FORM_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Mobile Lead Form Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable or disable mobile lead form",
    },
  ],

  METADATA_FIELDS: [],
};

